import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    EmailsContacto: { label: i18n.t('contact_email.entity_plural'), value: '' },
    codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
    ns: { label: i18n.t('app.serial_number'), value: '' },
    partner: { label: i18n.t('clients.partner'), value: '' },
    grupoCliente: { label: i18n.t('clients.grupo_cliente'), value: '', labelValue: '' },
    tipoServicio: { label: i18n.t('clients.service_type'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' }, 
    FaseConfiguracion: { label: i18n.t('clients.fase_config'), value: '' },
    PaqueteContratacion: { label: i18n.t('clients.paquete_contratacion'), value: '' },
    ModulosContratados: { label: i18n.t('clients.modulos_contratados'), value: '' },
    certificadoSAML2PorCaducar: { label: i18n.t('clients.certificadoSAML2PorCaducar_filter'), value: '' },
    certificadoSAML2Caducado: { label: i18n.t('clients.certificadoSAML2Caducado_filter'), value: '' },
  }
}
const getColumns =function getColumns () {
  return [
    { field: 'idCliente', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    { field: 'Nombre', width: '230px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    {
      field: 'EmailsContacto',
      width: '230px',
      title: i18n.t('contact_email.entity_plural'),
      columnMenu: 'myTemplate',
      locked: false,
      only: {
        roles: [3, 7, 8],
      }, 
    },
    {
      field: 'Activo',
      title: i18n.t('app.active'),
      hidden: false,
      columnMenu: 'myTemplate',
      width: '120px',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    { field: 'CodigoExterno', width: '200px', title: i18n.t('clients.cod_ext'), columnMenu: 'myTemplate', locked: false },
    { field: 'NumeroSerie', width: '200px', title: i18n.t('app.serial_number'), columnMenu: 'myTemplate', locked: false },
    { field: 'Partner', width: '150px', title: i18n.t('clients.partner'), columnMenu: 'myTemplate', locked: false },
    { field: 'GrupoCliente', width: '240px', title: i18n.t('clients.grupo_cliente'), columnMenu: 'myTemplate', locked: false },
    { field: 'MesesUserPass', width: '390px', title: i18n.t('clients.users_submenu.mesesUserPass'), format: '["MESES_USER_PASS_CADUC", "MESES_USER_PASS_CADUC_GRID"]', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, hidden: true, extraparams: { ignoreNull: false } },
    { field: 'idTipoServicio', width: '175px', title: i18n.t('clients.service_type'), format: 'TIPOS_SERVICIO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'FechaAlta', width: '200px', title: i18n.t('clients.fecha_alta'), format: 'numeric_datetime', type: 'date', filter: 'date', cell: 'fechaTemplate', columnMenu: 'myTemplate', locked: false, hidden: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'NumFacturas', width: '260px', title: i18n.t('license.num_invoices'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: false },
    // { field: 'NumVolumen', width: '300px', title: i18n.t('license.num_volumen_invoices'), columnMenu: 'myTemplate', locked: false, hidden: false },
    { field: 'NumeroCIFEmpresas', width: '200px', title: i18n.t('license.num_companies'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'NumeroUsuarios', width: '200px', title: i18n.t('license.num_users'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'RequiereOTP', width: '300px', title: i18n.t('clients.users_submenu.otp'), columnMenu: 'myTemplate', locked: false, hidden: true, cell: 'checkboxTemplate' },
    { field: 'CambioPassPrimerAcceso', width: '320px', title: i18n.t('clients.users_submenu.first_access'), columnMenu: 'myTemplate', locked: false, hidden: true, cell: 'checkboxTemplate' },
    { field: 'PagarAlContabilizar', width: '320px', title: i18n.t('clients.factura_submenu.auto_paid'), columnMenu: 'myTemplate', locked: false, hidden: true, cell: 'checkboxTemplate' },
    { field: 'idFaseConfiguracion', width: '225px', minResizableWidth: 168, title: i18n.t('clients.fase_config'), format: 'TIPOS_FASES_CONFIGURACION', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, hidden: false }, 
    { field: 'idPaqueteContratacion', width: '250px', minResizableWidth: 188, title: i18n.t('clients.paquete_contratacion'), format: 'TIPOS_PAQUETES_CONTRATACION', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, hidden: false }, 
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
